export default __webpack_public_path__ + "static/media/Tunic of the Unslaked.28673bbd.jpg";